<template>
    <div>
      <v-container class="grey lighten-5" style="padding:0px;margin-top:10px">
        <v-card dense :loading="loading" elevation="24" style="padding-top:0px" class="hidden-lg-and-up">
          <v-card-title class="my-0" style="padding-top:10px;background-color:#fbfbfb;border-bottom: 1px solid #D4D4D5;" >
              <div style="position:absolute;border: 1px solid #D4D4D5;border-left: 3px solid #560354;background: #FFFFFF;padding-left:7px;text-align:center;top:25px" >
                    <v-img 

                    style=" "
                    v-if="course.organization.photo_path"
                      max-width="60"
                      max-height="60"
                      :src="baseurl + '/img/'+course.organization.photo_path">
                    </v-img>
                </div>
                
              <v-container style="margin:0;padding:0; margin-top:10px;padding-left:75px;">
                <v-row >
                  <v-col cols="10">
                    <Link :href="baseurl+'/course/'+course.alias" class="text-lg-h5 text-md-h6">{{course.title}}</Link>
                  </v-col>
                  <v-col cols="2" class="text-right">
                    <v-icon color="blue" large v-if="course.isFeatured">mdi-seal</v-icon>
                    <v-icon v-if="!course.isFavorite" @click="triggerAddFavorite()" color="primary">mdi-heart-outline</v-icon>
                    <v-icon v-if="course.isFavorite" @click="triggerDelFavorite()" color="primary">mdi-heart</v-icon>
                  </v-col>
                </v-row>
              
              </v-container>
            </v-card-title>
            <v-card-subtitle style="margin-top:10px"> 
              <v-btn outlined color="blue" class="mr-2 mb-2" v-if="course.location == 'Online'"><v-icon>mdi-web</v-icon>&nbsp;{{ course.location }}</v-btn>
              <v-btn outlined color="teal" class="mr-2 mb-2" v-else="course.region"><v-icon>mdi-map</v-icon>&nbsp;{{ course.region }}</v-btn>
              <v-btn outlined color="indigo" class="mr-2 mb-2"  v-if="course.duration"><v-icon>mdi-clock</v-icon>&nbsp;{{ course.duration }}</v-btn>
            </v-card-subtitle>
            <v-card-text >
              <v-container style="padding:0;margin:0">
                <v-row>
                    <v-col cols="12" lg="12"><b><v-icon color="blue">mdi-office-building</v-icon>{{course.organization.name}}</b></v-col>
                    <v-col cols="12" lg="12" v-if="course.start_date && course.start_date != 'January 1, 1970'"><b>Enrolling: {{ course.start_date }}</b></v-col>
                    <v-col cols="12" lg="12" v-else><b>Enrolling: Now</b></v-col>
                  </v-row>
                  <v-row v-if="course.mobile_description" class="hidden-lg-and-up">
                      <v-col cols="12"  md="12">
                          <p v-html="course.mobile_description"></p>
                          <Link :href="baseurl+'/course/'+course.alias">More</Link>
                      </v-col>
                  </v-row>
                  <v-row v-if="0">
                    <v-col cols="12" sm="12" lg="4" md="6" v-if="course.region">
                        <span class="text-lg-h6 text-md-body-1">Location <a :href="getUrl()" target="_blank"><v-icon>mdi-map</v-icon></a></span>
                        <p><span v-if="course.address">{{ course.address }}</span>&nbsp;<span v-if="course.city">{{ course.city }}</span>&nbsp;<span v-if="course.postal_code">{{ course.postal_code }}</span>&nbsp;{{course.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4" md="6" v-if="course.awarding_body">
                        <span class="text-lg-h6 text-md-body-1">Awarding Body <v-icon>mdi-license</v-icon></span>
                      <p>{{ course.awarding_body }}</p>
                    </v-col>
                  </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="justify-center mt-0 pt-0">
                <v-container>
                  <v-row v-if="0">
                    <v-col cols="12" class="text-center justify-center">
                      <Link :href="baseurl+'/course/'+course.alias">
                        <v-btn color="primary"><v-icon style="margin-right:3px">mdi-eye</v-icon>Details</v-btn>
                      </Link>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center justify-center" v-if="canApply()">
                      <v-btn v-if="!course.isApplied" @click="triggerApply()" color="primary" class="ml-5"><v-icon style="margin-right:3px">mdi-send</v-icon>Request information</v-btn>
                      <v-btn v-if="course.isApplied" color="secondary" class="ml-5"><v-icon style="margin-right:3px">mdi-check</v-icon>Information requested</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
        </v-card>
        <v-card dense :loading="loading" elevation="24" style="padding-top:0px" class="hidden-md-and-down">
            <v-card-title class="my-0 " style="padding-top:10px;background-color:#fbfbfb;border-bottom: 1px solid #D4D4D5;">
              <div style="position:absolute;border: 1px solid #D4D4D5;border-left: 3px solid #560354;background: #FFFFFF;padding-left:7px;text-align:center;top:25px" >
                    <v-img 

                    style=" "
                    v-if="course.organization.photo_path"
                      max-width="100"
                      max-height="100"
                      :src="baseurl + '/img/'+course.organization.photo_path">
                    </v-img>
                </div>
                
              <v-container style="margin:0;padding:0; margin-top:10px;margin-left:120px;">
                <v-row >
                  <v-col cols="12" lg="11" md="11" sm="11">
                    <Link :href="baseurl+'/course/'+course.alias" class="text-lg-h5 text-md-h6">{{course.title}}</Link>
                    <v-icon color="blue" class="ml-3" large v-if="course.isFeatured">mdi-seal</v-icon>
                  </v-col>
                  <v-col cols="12" lg="1"  md="1" sm="1" class="text-right">
                    <v-icon v-if="!course.isFavorite" @click="triggerAddFavorite()" color="primary">mdi-heart-outline</v-icon>
                    <v-icon v-if="course.isFavorite" @click="triggerDelFavorite()" color="primary">mdi-heart</v-icon>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="12" sm="12">
                    <v-btn outlined color="blue" class="mr-2 mb-2" v-if="course.location == 'Online'"><v-icon>mdi-web</v-icon>&nbsp;{{ course.location }}</v-btn>
                    <v-btn outlined color="teal" class="mr-2 mb-2" v-else="course.region"><v-icon>mdi-map</v-icon>&nbsp;{{ course.region }}</v-btn>
                    <v-btn outlined color="indigo" class="mr-2 mb-2"  v-if="course.duration"><v-icon>mdi-clock</v-icon>&nbsp;{{ course.duration }}</v-btn>
                  </v-col>
                </v-row>
              
              </v-container>
            </v-card-title>
            
            <v-card-text style="margin-bottom:0x;">
              <v-container  class="pt-0 pb-0">
                  <v-row  style="margin:0px">
                    <v-col cols="12" lg="4" md="12" class="text-h6"><v-icon color="blue">mdi-office-building</v-icon><b>{{course.organization.name}}</b></v-col>
                    <v-col cols="12" lg="4" md="12" class="text-h6 text-center" v-if="course.start_date && course.start_date != 'January 1, 1970'"><v-icon color="green-darken-2">mdi-calendar-clock</v-icon><b>Enrolling: {{ course.start_date }}</b></v-col>
                    <v-col cols="12" lg="4" md="12" class="text-h6 text-center" v-else><v-icon color="green-darken-2">mdi-calendar-clock</v-icon><b>Enrolling: Now</b></v-col>
                    
                    <v-col class="text-right" cols="12" lg="4" md="12" v-if="canApply()">
                      <v-btn v-if="!course.isApplied" @click="triggerApply()" color="primary" class="ml-5"><v-icon style="margin-right:3px">mdi-send</v-icon>Request information</v-btn>
                      <v-btn v-if="course.isApplied" color="secondary" class="ml-5"><v-icon style="margin-right:3px">mdi-check</v-icon>Information requested</v-btn>
                    </v-col>
                  </v-row>
                   <v-row  v-if="course.description" class="hidden-md-and-down pt-0 pb-0"  style="margin:0px">
                      <v-col cols="12" md="12" class="pt-0 pb-0" v-if="!expanded">
                          <span v-html="course.description"></span>
                      </v-col>
                      <v-col cols="12" md="12" class="pt-0 pb-0" v-if="expanded">
                          <div class="rich-text" v-html="course.full_description"></div>
                      </v-col>
                  </v-row>
                  <v-row v-if="0">
                    <v-col cols="12" sm="12" lg="4" md="6" v-if="course.region">
                        <span class="text-lg-h6 text-md-body-1"><b>Location</b> <a :href="getUrl()" target="_blank"><v-icon>mdi-map</v-icon></a></span>
                        <p>{{course.region}}&nbsp;<a :href="getUrl()" target="_blank"><v-icon>mdi-open-in-new</v-icon></a></p>
                    </v-col>
                    <v-col cols="12" sm="12" lg="4" md="6" v-if="course.awarding_body">
                        <span class="text-lg-h6 text-md-body-1"><b>Awarding Body</b> <v-icon>mdi-license</v-icon></span>
                      <p v-html="course.awarding_body"></p>
                    </v-col>
                  </v-row>
                  
              </v-container>
            </v-card-text>
            <v-card-actions style="padding-top:0px">
              <Link :href="baseurl+'/course/'+course.alias"  v-if="expanded">
                    <v-btn color="primary"><v-icon style="margin-right:3px">mdi-eye</v-icon>Details</v-btn>
                </Link>
                
              <v-spacer></v-spacer>
              <v-icon large @click="expanded = !expanded" v-if="!expanded">mdi-chevron-down</v-icon>
              <v-icon large @click="expanded = !expanded" v-if="expanded">mdi-chevron-up</v-icon>
            </v-card-actions>
            <v-card-actions v-if="0" class="text-right"  style="padding-top:0x;">
                <Link :href="baseurl+'/course/'+course.alias"  v-if="expanded">
                    <v-btn color="primary"><v-icon style="margin-right:3px">mdi-eye</v-icon>Details</v-btn>
                </Link>
                <template v-if="canApply()">
                  <v-btn v-if="!course.isApplied" @click="triggerApply()" color="primary" class="ml-5"><v-icon style="margin-right:3px">mdi-send</v-icon>Request information</v-btn>
                  <v-btn v-if="course.isApplied" color="secondary" class="ml-5"><v-icon style="margin-right:3px">mdi-check</v-icon>Information requested</v-btn>
                </template>
              </v-card-actions>
          </v-card>   
      </v-container>
      <CourseApplyDialog 
        v-if="auth.user && !course.isApplied" 
        :user = "auth.user" 
        :dialog="applyDialog" 
        :course="course" 
        @close="applyDialog = false" 
        :baseurl="baseurl">
        </CourseApplyDialog>

    </div>
</template>
<script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
  import CourseApplyDialog from '@/Shared/CourseApplyDialog'
  import axios from 'axios'
  
import { Link } from '@inertiajs/inertia-vue'

  export default {
    props: {
      course: Object,
      auth: Object,
      state: String,
      baseurl: String,
      prevurl: String,
    },
    components: {
      Head,
      CourseApplyDialog,
      Link
    },
    layout: Layout,
    data() {
        return {
            applyDialog: false,
            loading: false,
            expanded: false
        }
    },
    watch: {
    },
    created() {
    },
    methods: {  
      getUrl() {
          return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(this.course.address +','+this.course.region)

      },
      canApply() {
        return 1;
        if (!this.auth.user || (this.auth.user.roles.includes('admin') || this.auth.user.roles.includes('user')))
            return true;
        else
            return false;
      },
      triggerApply() {
        console.log('trigger apply');
        /*if (this.auth.user)
            this.$emit('toggleComponentLogin','courseapply-'+this.course.id);
        else if (this.course.course_link)*/
            window.open(this.baseurl+'/course/'+this.course.alias+'/apply');//window.open(window.location + '/apply')
        /*else if (this.auth.user)
            this.applyDialog = true; */
            
      },
      triggerAddFavorite() {
        this.loading=true;
        console.log('trigger addfavorite');
        let vm = this;
        if (!this.auth.user)
            this.$emit('toggleComponentLogin','courseaddfavorite-'+this.course.id);
        else
            this.$inertia.get(this.baseurl+"/user/course/addfavorite/"+this.course.id,{},{
              preserveState: true,
              preserveScroll: true,
              onFinish: visit => {
                // This won't be called until doThing()
                // and doAnotherThing() have finished.
                vm.loading = false;
              },
            })
      },
      triggerDelFavorite() {
        this.loading = true;
        let vm = this;
        console.log('trigger delfavorite',this.auth.user,this.baseurl+"/user/course/delfavorite/"+this.course.id);
        if (!this.auth.user)
          this.$emit('toggleComponentLogin','coursedelfavorite-'+this.course.id);
        else
            this.$inertia.get(this.baseurl+"/user/course/delfavorite/"+this.course.id,{},{
              preserveState: true,
              preserveScroll: true,
              onFinish: visit => {
                vm.$emit('refresh');
                // This won't be called until doThing()
                // and doAnotherThing() have finished.
                vm.loading = false;
              },
            });
      }
    },
  }
  </script>
  
  <style>
    .fixedFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    color: white;
    text-align: center;
    }

    .logoWrap {
      position: absolute;
    top: 11px;
    left: 11px;
    width: 91px;
    height: 82px;
    text-align: center;
    padding: 3px 0px;
    }
    </style>